import { DEFAULT_LAYOUT } from '@/router/constants';
import { AppRouteRecordRaw } from '../types';

const ROUTERS: AppRouteRecordRaw = {
  path: '/discover',
  name: 'Discover',
  component: DEFAULT_LAYOUT,
  redirect: '/discover/app-market',
  meta: {
    locale: 'menu.discover.title',
    requiresAuth: false,
    hideFirstMenu: true,
    order: 0,
  },
  children: [
    {
      path: 'homepage',
      name: 'HomepageIndex',
      component: () => import('@/views/welcome/index.vue'),
      meta: {
        icon: 'icon-knit-home',
        locale: 'menu.homepage',
        requiresAuth: false,
        roles: ['*'],
      },
    },
    // {
    //   path: 'app-market',
    //   name: 'DiscoverAppMarket',
    //   component: () => import('@/views/discover/app-market.vue'),
    //   meta: {
    //     locale: 'menu.discover.appMarket',
    //     requiresAuth: false,
    //     icon: 'icon-apps',
    //     order: 0,
    //     hideChildrenInMenu: true,
    //   },
    // },
    {
      path: 'tool-market',
      name: 'DiscoverToolMarket',
      component: () => import('@/views/discover/tool-market.vue'),
      meta: {
        locale: 'menu.discover.toolMarket',
        requiresAuth: false,
        icon: 'icon-tool-marketplace',
        order: 0,
        hideChildrenInMenu: true,
      },
    },
    {
      path: 'tool-market/detail',
      name: 'DiscoverToolDetail',
      component: () => import('@/views/tool-detail/index.vue'),
      meta: {
        locale: 'menu.discover.toolDetail',
        requiresAuth: false,
        hideInMenu: true,
        activeMenu: 'DiscoverToolMarket',
      },
    },
  ],
};

export default ROUTERS;
